var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g2, _path36;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 502,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.652 469.224 126.9 479.826l-16.464-56.546 30.576-7.068 17.64 53.012Z",
    fill: "#F8C7C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.084 489.251s21.168 0 25.872-7.069c4.704-7.068-1.176-8.246-1.176-8.246s19.757-12.228 9.408-32.985c-7.056-14.137-16.464-11.781-16.464-11.781s14.112-11.78-18.816-11.78 1.176 71.861 1.176 71.861Z",
    fill: "#FE5565"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.548 432.704s14.112 23.561 2.352 42.41",
    stroke: "#fff",
    strokeWidth: 1.417,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.156 413.856s47.04-4.713 51.744 42.409c0 0 0 47.122-42.336 44.766-14.112-42.41-11.76-73.039-9.408-87.175Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.01 413.738s-1.552 57.159 8.986 86.963",
    stroke: "#FE5565",
    strokeWidth: 1.417,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.344 294.873s0-18.849 4.704-37.698 19.992-76.573 41.16-95.422c21.168-18.849 42.336-30.629 61.152-28.273 7.056 0 9.408-9.424 4.704-14.136-4.704-4.713 0-11.781 14.112-11.781h42.336s18.816 2.356 7.056 16.493c-7.056 9.424 18.816 11.78 18.816 11.78s42.336 7.068 58.8 37.698c16.464 30.629 39.984 103.668 37.632 124.873-2.352 21.205-42.336 47.122-89.376 49.478-47.04 2.356-117.6 0-117.6 0s-79.968 0-83.496-53.012Z",
    fill: "#E76D3B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.928 93.426h-25.872v40.054h25.872V93.426Z",
    fill: "#FFD6C2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.452 107.563c19.835 0 35.915-18.987 35.915-42.41 0-23.422-16.08-42.41-35.915-42.41s-35.915 18.988-35.915 42.41c0 23.422 16.08 42.41 35.915 42.41Z",
    fill: "#FFD8C6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.437 59.734c1.482-1.625 3.434-2.285 5.527-2.686 3.787-.706 5.927.99 8.702 3.228.988.801 2.423-.612 1.412-1.414-3.176-2.544-5.269-4.523-9.55-3.934-2.845.4-5.55 1.201-7.526 3.369-.847.99.565 2.403 1.435 1.437ZM199.718 60.465c3.811-5.773 11.172-3.134 15.594.023 1.059.754 2.046-.99 1.011-1.72-5.456-3.887-13.9-6.031-18.345.707-.706 1.06 1.035 2.05 1.74.99ZM174.528 69.865a3.53 3.53 0 0 0 3.528-3.534 3.53 3.53 0 0 0-3.528-3.534A3.531 3.531 0 0 0 171 66.331a3.531 3.531 0 0 0 3.528 3.534ZM207.457 69.865a3.531 3.531 0 0 0 3.528-3.534 3.531 3.531 0 0 0-3.528-3.534 3.53 3.53 0 0 0-3.528 3.534 3.53 3.53 0 0 0 3.528 3.534Z",
    fill: "#212121"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M213.337 88.714a4.708 4.708 0 0 0 4.704-4.712 4.708 4.708 0 0 0-4.704-4.712 4.708 4.708 0 0 0-4.704 4.712 4.708 4.708 0 0 0 4.704 4.712ZM171 88.714a4.708 4.708 0 0 0 4.704-4.712A4.708 4.708 0 0 0 171 79.29a4.708 4.708 0 0 0-4.704 4.712A4.708 4.708 0 0 0 171 88.714Z",
    fill: "#FFA5A2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149.833 60.441s-9.408-16.493-2.352-30.63c7.056-14.136 14.112-11.78 14.112-11.78s32.928-35.341 61.152-7.068c28.224 28.273 7.056 51.834 7.056 51.834s-5.88 1.178-8.232-12.958c-7.056 0-14.112 2.356-21.168-7.069-7.056 4.713-16.464 4.713-18.816 2.356l-7.056-7.068s-2.352 14.137-14.112 9.425c0 11.78-2.352 14.136-2.352 14.136s-4.704-4.712-8.232-1.178Z",
    fill: "#212121"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M187.935 84.332c2.399 1.06 4.916 1.037 7.268-.141 1.152-.59.141-2.31-1.012-1.72-1.646.824-3.551.918-5.245.141-1.176-.518-2.187 1.202-1.011 1.72ZM182.525 91.565c5.527 2.238 11.407 2.333 17.005.26 1.2-.448.682-2.38-.541-1.933-5.292 1.956-10.702 1.862-15.947-.259-1.176-.495-1.693 1.437-.517 1.932Z",
    fill: "#FFA5A2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.184 72.222c3.897 0 7.056-3.165 7.056-7.069 0-3.903-3.159-7.068-7.056-7.068-3.897 0-7.056 3.165-7.056 7.068 0 3.904 3.159 7.069 7.056 7.069ZM229.8 74.578c3.897 0 7.056-3.165 7.056-7.069 0-3.903-3.159-7.068-7.056-7.068-3.897 0-7.056 3.165-7.056 7.068 0 3.904 3.159 7.069 7.056 7.069Z",
    fill: "#FFD8C6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.161 63.834c1.341-.047 2.446.565 3.505 1.32 1.058.753 2.046-.99 1.011-1.72-1.364-.967-2.822-1.65-4.516-1.603-1.27.024-1.293 2.026 0 2.003ZM229.401 68.31c1.364-1.107 2.822-1.932 4.633-1.743 1.27.118 1.27-1.885 0-2.003-2.328-.235-4.28.92-6.044 2.333-1.012.8.423 2.215 1.411 1.413Z",
    fill: "#000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M180.409 133.48h21.168l-12.936 50.656-8.232-50.656Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M225.567 116.445c-1.693 1.438-6.586 5.113-15.758 8.789-16.464 9.424-18.816 58.902-18.816 58.902v73.039h-2.352V224.19c0-5.985 1.199-22.996 0-40.054-1.176-16.54-4.728-33.103-5.88-41.232-1.858-13.005-17.617-22.359-24.179-25.728-2.046-1.06-2.517-3.793-.894-5.419 1.811-1.814 5.292-3.652 11.972-4.194 11.384-.942 34.645-1.131 43.583-1.178 2.469 0 4.868.73 6.914 2.144 2.776 1.932 5.222 4.123 5.904 6.173.212.636 0 1.319-.494 1.743Z",
    stroke: "#FFBC25",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M203.928 105.207h-25.872v9.424h25.872v-9.424Z",
    fill: "#FFD6C2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M241.56 218.3c7.794 0 14.112-6.33 14.112-14.137s-6.318-14.137-14.112-14.137c-7.794 0-14.112 6.33-14.112 14.137s6.318 14.137 14.112 14.137Z",
    fill: "#FFBC25"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M106.368 377.336s28.224 84.819 49.392 96.6c25.872 0 47.04-4.712 47.04-4.712s-63.504-101.312-63.504-108.381c-23.52 9.425-35.28 11.781-32.928 16.493Z",
    fill: "#6E7AE3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M226.272 365.556s87.024-51.834 115.248-51.834",
    stroke: "#23349B",
    strokeWidth: 2.835,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M122.784 177.068s-9.408 68.327-7.056 70.683",
    stroke: "#DE4E26",
    strokeWidth: 2.126,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.208 247.751s58.8 0 77.616 7.068M273.312 179.424s9.408 68.327 7.056 70.683",
    stroke: "#DE4E26",
    strokeWidth: 2.126,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M303.888 250.107s-58.8 0-77.616 7.068",
    stroke: "#DE4E26",
    strokeWidth: 2.126,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m109.848 241.861 11.525 99.38a2.17 2.17 0 0 0 2.164 1.932h143.26a3.398 3.398 0 0 0 3.364-2.945l13.712-98.367H109.848Z",
    fill: "#CEDEED"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M109.848 241.861v-5.914c0-.636.518-1.155 1.153-1.155l169.273-2.332a1.64 1.64 0 0 1 1.6 1.225l2.046 8.176H109.848Z",
    fill: "#82BADC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M198.048 298.407c5.846 0 10.584-4.747 10.584-10.603 0-5.855-4.738-10.602-10.584-10.602-5.845 0-10.584 4.747-10.584 10.602 0 5.856 4.739 10.603 10.584 10.603Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "people_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 292,
    width: 250,
    height: 166
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M200.59 457.349s79.968-11.78 119.952-37.698c39.984-25.917 65.856-61.258 68.208-82.463 2.352-21.205-11.76-47.122-47.04-44.766-35.28 2.356-103.488 21.205-152.88 42.41l-49.392 21.205s42.336 96.6 61.152 101.312Z",
    fill: "#484ED0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#people_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.545 457.349s79.968-11.78 119.952-37.698c39.984-25.917 65.856-61.258 68.208-82.463 2.352-21.205-11.76-47.122-47.04-44.766-35.28 2.356-103.488 21.205-152.88 42.41l-49.392 21.205s42.336 96.6 61.152 101.312Z",
    fill: "#484ED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.806 353.681s-96.009 70.4-229.462 83.665",
    stroke: "#8994F7",
    strokeWidth: 2.835,
    strokeMiterlimit: 10
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M116.748 368.133s28.224 84.819 49.392 96.6c25.872 0 47.04-4.712 47.04-4.712s-63.504-101.312-63.504-108.381c-23.52 9.425-35.28 11.781-32.928 16.493Z",
    fill: "#6E7AE3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M210.071 366.94s87.024-51.834 115.248-51.834",
    stroke: "#23349B",
    strokeWidth: 2.835,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m240.385 450.375 31.752 10.603 16.464-56.547-30.576-7.068-17.64 53.012Z",
    fill: "#F8C7C1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M290.953 470.402s-21.168 0-25.872-7.068c-4.704-7.069 1.176-8.247 1.176-8.247s-19.757-12.228-9.408-32.985c7.056-14.137 16.464-11.78 16.464-11.78s-14.112-11.781 18.816-11.781-1.176 71.861-1.176 71.861Z",
    fill: "#FE5565"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M274.489 413.856s-14.112 23.561-2.352 42.409",
    stroke: "#fff",
    strokeWidth: 1.417,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M323.881 395.007s-47.04-4.712-51.744 42.41c0 0 0 47.122 42.336 44.765 14.112-42.409 11.76-73.039 9.408-87.175Z",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M314.026 394.889s1.552 57.159-8.985 86.964",
    stroke: "#FE5565",
    strokeWidth: 1.417,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "people_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 296,
    width: 250,
    height: 166
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M188.41 461.916s-79.968-11.781-119.952-37.698C28.474 398.301 2.602 362.96.25 341.755c-2.352-21.205 11.76-47.122 47.04-44.766 35.28 2.356 103.488 21.205 152.88 42.41l49.392 21.205s-42.336 96.6-61.152 101.312Z",
    fill: "#484ED0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#people_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.455 461.916s-79.968-11.781-119.952-37.698C28.519 398.301 2.647 362.96.295 341.755c-2.352-21.205 11.76-47.122 47.04-44.766 35.28 2.356 103.488 21.205 152.88 42.41l49.392 21.205s-42.336 96.6-61.152 101.312Z",
    fill: "#484ED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.251 329.974s96.009 70.401 229.461 83.665M-6.806 358.247s96.009 70.401 229.462 83.665",
    stroke: "#8994F7",
    strokeWidth: 2.835,
    strokeMiterlimit: 10
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M272.252 372.7s-28.224 84.819-49.392 96.6c-25.872 0-47.04-4.712-47.04-4.712s63.504-101.313 63.504-108.381c23.52 9.424 35.28 11.781 32.928 16.493Z",
    fill: "#6E7AE3"
  })));
};
export default SvgPeople;